import { ACTIVE_GRID_TRANSPORT, GRID_TRANSPORT, createListQuery } from './listQuery';

/**
 * Map our ListQuery → current Kendo.DynamicLinq DataSourceRequest body.
 * Remove this file after all endpoints are on .NET Core + NEUTRAL transport.
 */
export const toKendoRequest = (listQuery) => {
  const q = createListQuery(listQuery || {});
  const body = {
    Skip: q.skip,
    Take: q.take,
  };

  if (q.sort?.length) {
    body.Sort = q.sort.map((s) => ({
      Field: s.field,
      Dir: s.dir === 'desc' ? 'desc' : 'asc',
    }));
  }

  if (q.filter) {
    body.Filter = mapFilterToKendo(q.filter);
  }

  return body;
};

const mapFilterToKendo = (node) => {
  if (!node) return null;
  if (node.filters && Array.isArray(node.filters)) {
    return {
      Logic: node.logic === 'or' ? 'or' : 'and',
      Filters: node.filters.map(mapFilterToKendo).filter(Boolean),
    };
  }
  return {
    Field: node.field,
    Operator: node.operator,
    Value: node.value,
  };
};

/**
 * Normalize API list result to { data, total } (works for Kendo or neutral).
 */
export const normalizeGridResult = (response) => {
  if (response == null) return { data: [], total: 0 };

  if (Array.isArray(response)) {
    return { data: response, total: response.length };
  }

  const data =
    response.data ??
    response.Data ??
    response.items ??
    response.Items ??
    [];

  const totalRaw =
    response.total ??
    response.Total ??
    response.count ??
    response.Count;

  const list = Array.isArray(data) ? data : [];
  const total = totalRaw != null ? Number(totalRaw) : list.length;

  return {
    data: list,
    total: Number.isFinite(total) ? total : list.length,
  };
};

/**
 * Serialize ListQuery for the active transport.
 */
export const serializeListQuery = (
  listQuery,
  transport = ACTIVE_GRID_TRANSPORT
) => {
  if (transport === GRID_TRANSPORT.NEUTRAL) {
    return createListQuery(listQuery);
  }
  return toKendoRequest(listQuery);
};
